// src/components/DashboardRightModules.jsx
import React from "react";
import ManualiCard from "./ManualiCard";
import NonConformitaCard from "./NonConformitaCard";

export default function DashboardRightModules() {
    // ✅ su mobile/tablet non mostriamo nulla
    // ✅ compare solo da xl in su (desktop grande) come nel Figma a destra
    return (
        <aside className="hidden xl:block">
            <div className="space-y-6">
                <ManualiCard />
                <NonConformitaCard to="/non-conformita" />
            </div>
        </aside>
    );
}